import { createClient, type SupabaseClientOptions } from '@supabase/supabase-js';

export type SbFromEnvOptions<Database = any> = {
  url?: string;
  key?: string;
  headers?: Record<string, string>;
  options?: SupabaseClientOptions<Database>;
};

export function sbFromEnv<Database = any>(opts: SbFromEnvOptions<Database> = {}) {
  const url = opts.url ?? process.env.SUPABASE_URL ?? process.env.VITE_SUPABASE_URL;
  const key =
    opts.key ??
    process.env.SUPABASE_ANON_KEY ??
    process.env.VITE_SUPABASE_ANON_KEY ??
    process.env.SUPABASE_SERVICE_ROLE_KEY ??
    process.env.SUPABASE_SERVICE_ROLE ??
    process.env.SUPABASE_SERVICE_KEY;

  if (!url || !key) {
    throw new Error('Missing Supabase configuration');
  }

  const baseOptions = opts.options ?? {};
  const { db: baseDb, global: baseGlobal, ...restOptions } = baseOptions;

  const hasHeaders = Boolean(opts.headers) || Boolean(baseGlobal?.headers);
  const mergedGlobal = baseGlobal || hasHeaders
    ? {
        ...(baseGlobal ?? {}),
        ...(hasHeaders
          ? {
              headers: {
                ...(baseGlobal?.headers ?? {}),
                ...(opts.headers ?? {}),
              },
            }
          : {}),
      }
    : undefined;

  const finalSchema = baseDb?.schema ?? 'public';
  const finalDb = {
    ...(baseDb ?? {}),
    schema: finalSchema,
  };

  const finalOptions = {
    ...restOptions,
    ...(mergedGlobal ? { global: mergedGlobal } : {}),
    db: finalDb,
  } as SupabaseClientOptions<Database>;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return createClient(url, key, finalOptions as any) as ReturnType<typeof createClient<Database>>;
}
